import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type UpdateBillPayerNotesResponse} from './bill-payer-notes-data';

export function updateBillPayerNotesTypePatcher(
    response: UpdateBillPayerNotesResponse,
): RestTypeWithTypename<UpdateBillPayerNotesResponse> {
    return {
        ...response,
        __typename: 'UpdateBillPayerNotesResponse',
        billPayers: response.billPayers.map(billPayer => ({
            ...billPayer,
            __typename: 'BillPayer',
        })),
    };
}
